import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ProjectsCTA() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-20 px-6 border-t border-gray-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-6">
          <span className="w-1 h-1 bg-amber-500 rounded-full" />
          <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('projects.cta.badge')}</span>
        </div>
        <h2 className="text-gray-900 text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {t('projects.cta.heading1')}<br />
          <span className="text-amber-500">{t('projects.cta.heading2')}</span>
        </h2>
        <p className="text-gray-500 text-sm leading-relaxed mb-8 max-w-md mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>{t('projects.cta.desc')}</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/#contact" className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white px-8 py-3.5 rounded-full text-sm font-bold tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('projects.cta.getQuote')}
            <i className="ri-arrow-right-line" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 border border-gray-200 text-gray-600 hover:border-amber-400 hover:text-amber-600 px-8 py-3.5 rounded-full text-sm font-medium tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            <i className="ri-home-line" />
            {t('projects.cta.homePage')}
          </Link>
        </div>
      </div>
    </section>
  );
}